import { render, staticRenderFns } from "./Rule2.vue?vue&type=template&id=4d1c4605&scoped=true&"
import script from "./Rule2.vue?vue&type=script&lang=js&"
export * from "./Rule2.vue?vue&type=script&lang=js&"
import style0 from "./Rule2.vue?vue&type=style&index=0&id=4d1c4605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c4605",
  null
  
)

export default component.exports